export const UserInteractionEvent =
  "web_analytics.tracking.user_interaction.UserInteractionEvent";
export const PageViewEvent = "web_analytics.tracking.page_view.PageViewEvent";

export const RevenueSystemName = "Revenue";

export enum InteractionName {
  contact_sales = "contact_sales",
  call_to_action = "call_to_action",
  component_scrolled_into_view = "component_scrolled_into_view",
  popover_opened = "popover_opened",
  popover_closed = "popover_closed",
  popover_link_clicked = "popover_link_clicked",
  open_faq = "open_faq",
  task_tier_option = "task_tier_option",
  toggle = "toggle",
  navigation = "navigation",
  task_selector_changed = "task_selector_tier_changed",
  plan_card_footer_link_clicked = "plan_card_footer_link_clicked",
}

export enum EventAction {
  click = "click",
  deselect = "deselect",
  enter = "enter",
  select = "select",
  in_view = "in_view",
}

export enum OptionSelected {
  section = "section",
  cta_button = "cta_button",
  opening = "opening",
}

export enum InteractionRawTextEnum {
  try_free = "Try free",
  contact_sales = "Contact Sales",
}

export enum DestinationUrlAddressEnum {
  contact_sales = "/l/contact-sales",
  sign_up = "/sign-up",
}

export enum SectionName {
  FAQs = "FAQs",
}
